import { render, staticRenderFns } from "./YextImportBusinessDataModal.vue?vue&type=template&id=53a6b44c"
import script from "./YextImportBusinessDataModal.vue?vue&type=script&lang=ts"
export * from "./YextImportBusinessDataModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports